module.exports = __webpack_public_path__ + "static/media/img-add-photo.6db3b5b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/img-add-photo.svg
// module id = 30
// module chunks = 0